import React from "react"
import "./menu.css"


function Menu() {
  return (
    <div className='menu-container'>
      <div className='logo'>
      <div className="btn-book">
          <a href="https://cal.com/nazmulrdo" target="_blank" rel="noreferrer">Book a call</a>
        </div>
        {/* <img src={logo} alt="" /> */}
      </div>
      <div className='menu'>
        <ul><a href="/">Home</a></ul>
        <ul><a href="#Aboutus">About</a></ul>
        <ul><a href="#skills">Skills</a></ul>
        <ul><a href="#protfilio">Protfilio</a></ul>
        <ul><a href="#contact">Contact us</a></ul>
        
      </div>
    </div>
  );
}
export default Menu;
